<template>
	<div>
		<div class="mgb20" ref='editor' id="container"></div>
	</div>
</template>

<script>
	import E from 'wangeditor'
	export default {
		data() {
			return {
				editor: null,
				imgUrl: '',
				content: this.Introduction,
				token: localStorage.getItem('access_token')
			}
		},
		props: ['Introduction', 'isbianji'],
		mounted() {
			this.editor = new E('#container')
			this.editor.config.uploadImgServer =  this.$store.state.pcurl + 'EditorImgUpload'
			if(this.$route.path=='/cgList'){
				this.editor.config.placeholder = '根绝微信公众号内容规定，外链的图片会被自动过滤屏蔽'
			}else{
				this.editor.config.placeholder = '请输入内容'
			}
			this.editor.config.uploadImgHeaders = {
				Authorization:'bearer ' + this.token
			}
			this.editor.config.uploadImgMaxSize = 0.5 * 1024 * 1024 // 2M
			this.editor.config.uploadImgHooks = {
				// 上传图片之前
				before: function(xhr, editor, files) {
					// 图片上传之前触发
					// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件

					// 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
					// return {
					//     prevent: true,
					//     msg: '放弃上传'
					// }
				},
				success: function(xhr, editor, result) {
					console.log(result)
					// 图片上传并返回结果，图片插入成功之后触发
					// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
				},
				fail: function(xhr, editor, result) {
					console.log(result)
					// 图片上传并返回结果，但图片插入错误时触发
					// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
				},
				error: function(xhr, editor) {
					// 图片上传出错时触发
					// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
				},
				timeout: function(xhr, editor) {
					// 图片上传超时时触发
					// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
				},

				// 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
				// （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
				customInsert: function(insertImg, result, editor) {
					// 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
					// insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

					// 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
					insertImg(result.Data[0].url)
					console.log(result)

					// result 必须是一个 JSON 格式字符串！！！否则报错
				}
			}
			this.editor.create()
			this.editor.txt.html(this.Introduction)
		},
		updated() {
			this.editor.txt.html(this.Introduction)
		},
		methods: {
			syncHTML() {
				console.log(this.editor.txt.html())
				this.content = this.editor.txt.html()
				this.$emit('childvalue', this.content)
			},
		}
	}
</script>

<style scoped>
	.mgb20 {
		margin-bottom: 20px;
	}
</style>
